import { useEffect } from "react";
import { CookiesProvider } from "react-cookie";
import { persistor, store } from "./store/index.js";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { Toaster } from "react-hot-toast";
import { ConfigProvider, Empty } from "antd";
import AppRoutes from "./routes/AppRoutes.jsx";
// import { SupportProvider } from "./contexts/SupportContext.jsx";

const App = () => {
  const primaryColor = (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim();

  // useEffect(() => {
  //   const name = getEnv("VITE_NAME", "Fxcrm");
  //   if (name) document.title = `Cabinet - ${name}`;
  // }, []);

  return (
    <CookiesProvider>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <ConfigProvider
            renderEmpty={() => <Empty description="No Record Found" image={Empty.PRESENTED_IMAGE_SIMPLE} />}
            theme={{ token: { fontFamily: "Public Sans", colorPrimary: primaryColor } }}
          >
            <Toaster
              position="top-right"
              reverseOrder={false}
              toastOptions={{ duration: 4000 }}
            />
            {/* <SupportProvider> */}
            <AppRoutes />
            {/* </SupportProvider> */}
          </ConfigProvider>
        </PersistGate>
      </Provider>
    </CookiesProvider>
  );
};

export default App;